import { createContext, useContext } from 'react';

// One context for both primitives — FeedbackProvider supplies the whole
// value. Splitting toast and confirm into two contexts would just mean two
// providers to wire in two apps for no real benefit.
export const FeedbackContext = createContext(null);

function useFeedback() {
  const ctx = useContext(FeedbackContext);
  if (!ctx) {
    throw new Error('useToast/useConfirm must be used inside <FeedbackProvider>.');
  }
  return ctx;
}

// useToast() -> { success, error, info, show, dismiss }
//   success(message, { duration? })  — message is ALREADY translated by the
//     caller (which has t()/lang in scope). Default duration 5s; error 8s.
//   show({ kind, message, duration }) — the general form.
export function useToast() {
  return useFeedback().toast;
}

// useConfirm() -> confirm(options) => Promise<boolean>
//   options: { title, message, confirmLabel?, cancelLabel?, tone? }
//   All strings are already translated by the caller; confirmLabel /
//   cancelLabel fall back to the provider's localized defaults. tone:
//   'default' | 'danger' (danger = irreversible / financial — the confirm
//   button is styled to give pause and focus starts on Cancel).
//   Resolves true if confirmed, false if cancelled / dismissed / Escape.
export function useConfirm() {
  return useFeedback().confirm;
}
